

export const DEFAULT_CREATE_PAGE_DATA = {
  name: '',
  subdomain: '', // Empty string means main page
  template: '',
  createNavbar: false,
  addToNavbar: false,
  createLeftSidebar: false,
  addToLeftSidebar: false,
  createRightSidebar: false,
  addToRightSidebar: false
};

export const NAVIGATION_TYPES = {
  NAVBAR: 'navbar',
  LEFT_SIDEBAR: 'leftSidebar',
  RIGHT_SIDEBAR: 'rightSidebar',
  FOOTER: 'footer'
};

export const API_ENDPOINTS = {
  // Align with dashboard behavior
  PUBLISH: (websiteId) => `/api/websites/${websiteId}/publish-version/`,
  PREPARE_FOR_EDIT: (websiteId) => `/api/websites/${websiteId}/prepare-for-edit/`,
  PAGE_UPDATE: (websiteId, pageId) => `/api/websites/${websiteId}/pages/${pageId}/update/`,
  PAGE_UPDATE_BY_SUBDOMAIN: (websiteId, subdomain) => `/api/websites/${websiteId}/pages/${subdomain}/update/`,
  PAGE_DELETE: (websiteId, subdomain) => `/api/websites/${websiteId}/pages/${subdomain}/delete/`,
  PAGE_CREATE: (websiteId) => `/api/websites/${websiteId}/pages/create/`,
  PAGE_CREATE_FROM_TEMPLATE: (websiteId) => `/api/websites/${websiteId}/pages/create-from-template/`,
  PAGE_TEMPLATES: () => `/api/page-templates/`,
  // Navbar
  NAVBAR_GET: (websiteId) => `/api/websites/${websiteId}/navbar/`,
  NAVBAR_UPDATE: (websiteId) => `/api/websites/${websiteId}/navbar/update/`,
  NAVBAR_DELETE: (websiteId) => `/api/websites/${websiteId}/navbar/delete/`,
  NAVBAR_SECTIONS_CREATE: (navbarId) => `/api/websites/${navbarId}/navbar/sections/create/`,
  NAVBAR_SECTIONS_DELETE: (navbarId, sectionId) => `/api/websites/${navbarId}/navbar/sections/${sectionId}/delete/`,
  // Left Sidebar
  LEFTSIDEBAR_GET: (websiteId) => `/api/websites/${websiteId}/leftsidebar/`,
  LEFTSIDEBAR_UPDATE: (websiteId) => `/api/websites/${websiteId}/leftsidebar/update/`,
  LEFTSIDEBAR_DELETE: (websiteId) => `/api/websites/${websiteId}/leftsidebar/delete/`,
  LEFTSIDEBAR_SECTIONS_CREATE: (sidebarId) => `/api/websites/${sidebarId}/leftsidebar/sections/create/`,
  LEFTSIDEBAR_SECTIONS_DELETE: (sidebarId, sectionId) => `/api/websites/${sidebarId}/leftsidebar/sections/${sectionId}/delete/`,
  // Right Sidebar
  RIGHTSIDEBAR_GET: (websiteId) => `/api/websites/${websiteId}/rightsidebar/`,
  RIGHTSIDEBAR_UPDATE: (websiteId) => `/api/websites/${websiteId}/rightsidebar/update/`,
  RIGHTSIDEBAR_DELETE: (websiteId) => `/api/websites/${websiteId}/rightsidebar/delete/`,
  RIGHTSIDEBAR_SECTIONS_CREATE: (sidebarId) => `/api/websites/${sidebarId}/rightsidebar/sections/create/`,
  RIGHTSIDEBAR_SECTIONS_DELETE: (sidebarId, sectionId) => `/api/websites/${sidebarId}/rightsidebar/sections/${sectionId}/delete/`,
  // Footer
  FOOTER_GET: (websiteId) => `/api/websites/${websiteId}/footer/`,
  FOOTER_UPDATE: (websiteId) => `/api/websites/${websiteId}/footer/update/`,
  FOOTER_SECTIONS_CREATE: (footerId) => `/api/websites/${footerId}/footer/sections/create/`,
  FOOTER_SECTIONS_DELETE: (footerId, sectionId) => `/api/websites/${footerId}/footer/sections/${sectionId}/delete/`,
  CONTAINER_VERSIONS: (containerId) => `/api/containers/${containerId}/versions/`
}; 